import React from "react";

export default () => (
  <svg
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m 6.716235,0 1.75976,1.68169 -4.84392,4.62901 h 11.9278 V 8.68896 H 3.631775 L 8.475995,13.3183 6.716235,15 0.770775,9.30546 c -1.0277,-0.98429 -1.0277,-2.62663 0,-3.61092 z"
      fill="#008cff"
      id="path20"
    />
  </svg>
);
